import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { FETCH_USER_DATA } from '../../redux/UserData';
import { SET_IS_MOBILE } from '../../redux/Layout';
import HeaderContainer from '../Header/HeaderContainer';
import BreadcrumbsContainer from '../Breadcrumbs/BreadcrumbsContainer';
import Menu from '../Menu/Menu';
import '../../fonts/main.css'
import '../../fonts/bootstrap.min.css'
import '../Table/Table.scss';
import './Default.scss';
import '../../fonts/bootstrap.min.js'
import { sockets } from '../../helpers/Sockets';
import MobileAppBanner from '../MobileAppBanner/MobileAppBanner.jsx';

class Layout extends Component {
  componentDidMount() {
    const { location: { pathname, }, } = this.props;
    if (!pathname.includes('auth')) {
      this.props.fetchUserData();
      sockets.initializeSockets();
    }
    this.manageWindowMedia();
  }

  manageWindowMedia() {
    this.matchMedia = window.matchMedia('(min-width: 992px)');
    this.props.setIsMobile(!this.matchMedia.matches);
    this.matchMedia.addListener((value) => this.props.setIsMobile(!value.matches));
  }

  render() {
    const { children, isMenuOpened, location: { pathname, state, }, } = this.props;
    const whichFolder = state ? state.whichFolder : null;
    return (
      <div>
        <MobileAppBanner />
        {pathname.includes('auth') ? (<div>{children}</div>) : (
          <div className="row application-container">
            <div className="row">
              <HeaderContainer pathname={pathname} />
            </div>
            <div className="row">
              { this.props.isMobile ? (isMenuOpened && <Menu />) : <Menu /> }
              <BreadcrumbsContainer pathname={pathname} whichFolder={whichFolder} />
              <div className="col-md-10 children-container">{children}</div>
            </div>
            <style>{`
              .application-container {
                background-color: #fff;
                max-width: 1170px;
                margin: auto;
                -moz-osx-font-smoothing: grayscale;
                -webkit-font-smoothing: antialiased;
              }
              .children-container {
                border-left: 1px solid #e5e3e8;
              }
              `}</style>
          </div>
        )}

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isMenuOpened: get(state, ['layout', 'isMenuOpened']),
    isMobile: get(state, ['layout', 'isMobile']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchUserData: () => dispatch(FETCH_USER_DATA()),
    setIsMobile: (payload) => dispatch(SET_IS_MOBILE(payload)),
  };
};

Layout.propTypes = {
  isMenuOpened: PropTypes.bool,
  setIsMobile: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired,
  fetchUserData: PropTypes.func.isRequired,
};

Layout.defaultProps = {
  isMenuOpened: false,
  isMobile: true,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));
